import { forwardRef } from 'react';
import { onlyDigits } from '@amai/contracts';
import { maskCep, maskDocument, maskPhone } from '@/lib/masks';

/**
 * Campo de texto com máscara. O que sai daqui é sempre SÓ DÍGITOS: a máscara
 * é apresentação, o banco guarda o dado limpo.
 */
const MASKS = {
  document: { fn: maskDocument, max: 14, placeholder: '00.000.000/0000-00' },
  cpf: { fn: maskDocument, max: 11, placeholder: '000.000.000-00' },
  phone: { fn: maskPhone, max: 11, placeholder: '(00) 00000-0000' },
  cep: { fn: maskCep, max: 8, placeholder: '00000-000' },
} as const;

export type MaskKind = keyof typeof MASKS;

interface MaskedInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  mask: MaskKind;
  /** Só dígitos — a máscara é aplicada na exibição. */
  value: string;
  /** Recebe só dígitos, prontos para gravar. */
  onChange: (digits: string) => void;
}

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(function MaskedInput(
  { mask, value, onChange, className, placeholder, ...rest },
  ref,
) {
  const config = MASKS[mask];
  return (
    <input
      {...rest}
      ref={ref}
      className={className ?? 'input input--mono'}
      inputMode="numeric"
      autoComplete="off"
      placeholder={placeholder ?? config.placeholder}
      value={config.fn(onlyDigits(value ?? ''))}
      onChange={(event) => onChange(onlyDigits(event.target.value).slice(0, config.max))}
    />
  );
});
